import { Stack } from 'expo-router';

/**
 * Auth route group — access-gate screens shown before onboarding/app entry
 * (currently the email-confirmation gate, onboarding redesign D2). The group is
 * transparent in the URL, so `confirm-email` is reachable at `/confirm-email`.
 */
export default function AuthLayout() {
  return (
    <Stack
      screenOptions={{
        headerShown: false,
        gestureEnabled: false,
        animation: 'slide_from_right',
      }}
    >
      <Stack.Screen name="confirm-email" />
    </Stack>
  );
}
